import config from '../config';
import { AgentAllocationResponse } from '../models/AgentsAllocation';
import { getAgentAllocationLabel } from '../utils/agentAllocationLabel';
import { formatAgentAvailability } from '../utils/formatAgentAvailability';
import { formatDuration } from '../utils/formatDuration';

export const fetchAgentsAllocation = async (): Promise<AgentAllocationResponse> => {
  const apiUrl = config.catoApiUrl;

  if (!apiUrl) {
    throw new Error('Agent Allocation API Url is not configured');
  }

  const url = `${apiUrl}/agents`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch agents allocation data: ${response.status} ${response.statusText}`);
  }

  let data = (await response.json()) as AgentAllocationResponse;

  //TODO: Remove this from here once the backend is fixed to return proper JSON
  if (typeof data === 'string') {
    data = JSON.parse(data) as AgentAllocationResponse;
  }

  const formattedAgents = data.agentAllocation.map(agent => ({
    ...agent,
    duration: formatDuration(Number(agent.duration)),
    availability: formatAgentAvailability(agent.availability),
    label: getAgentAllocationLabel(agent)
  }));

  return {
    ...data,
    agentAllocation: formattedAgents
  };
};
